/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Wine(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M209.73047,110.01318,183.67285,21.73535A7.99985,7.99985,0,0,0,176,16H80a7.99985,7.99985,0,0,0-7.67285,5.73535L46.26953,110.01367A31.984,31.984,0,0,0,47.791,132.24951,88.23263,88.23263,0,0,0,120,183.62012V224H88a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16H136V183.62012a88.2322,88.2322,0,0,0,72.209-51.3711A31.98167,31.98167,0,0,0,209.73047,110.01318ZM131.57764,96.84473C105.398,83.75488,84.38428,83.76318,69.66943,87.25586L85.97949,32h84.041l20.8125,70.5083C180.05664,107.001,159.75586,110.93359,131.57764,96.84473Z" />
    </Svg>
  );
}

export default Wine;
